export const getCourseCatalogComponentState = ({components: {courseCatalog: {state: courseCatalogState}}}) => courseCatalogState;

export const getCourseCatalogLayoutConfig = ({components: {courseCatalog: {layout}}}) => layout || {};
